import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprControlInfo } from '../../view/control/WprControlInfo';
import { WprFramework } from '../../WprFramework';
import { WprControlVisibility } from '../props/IWprControlState';
import { WprBaseInputControlComponent } from './WprBaseInputControlComponent';

/**
 * 選択コントロールプロパティ情報
 */
interface IWprSelectProps extends IWprControlProps {
	vm: string;				// ValueMap名
	placeholder?: string;	// placeholder
}

/**
 * 選択コントロール
 */
export class WprSelect extends WprBaseInputControlComponent<IWprSelectProps, HTMLSelectElement> {
	// プロパティ  ---------------------------------------------------------------
	/** ValueMap保持フラグ */
	public get hasValueMap(): boolean	{ return true; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprSelectProps) {
		super(props);
		this.setChangeValueEvent(this.onChangeValue.bind(this));
	}
	// --------------------------------------------------------------------------

	// イベント  ----------------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		if (this.state.value == null)
			return '';
		return this.state.value;
	}

	/**
	 * 値変更処理
	 * @param event 変更イベント 
	 */
	public onChangeValue(event: React.ChangeEvent<HTMLSelectElement>): void {
		const value = event.target.value;
		// const name = event.target.name;
		if (this.controlInfo != null) {
			WprControlInfo.isChangeValue = true;
			try {
				WprFramework.getInstance().view.setScopeUpdateProperty();
				this.controlInfo.dirty = true;
				if (this.props.row) {
					if (this.controlInfo.changeListValue(value, this.props.row.rowData) === false)
						return;
				}
				else {
					if (this.controlInfo.changeValue(value) === false)
						return;
				}
				this.controlInfo.value = value;
				this.controlInfo.viewCore.viewInfo.checkScopeModelValue();
			}
			finally {
				WprControlInfo.isChangeValue = false;
			}
		}
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps('wpr-select');
		const {name, view, vm, className, placeholder, children, ...other} = this.props;
		const state = this.getState(['style', 'disabled']);
		const events = this.getEvents();
		const options = this.getOptionList();
		let select = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			select = <select {...props} {...state} {...other} {...events}>{options}</select>;
		}
		else {
			state['style'] = {...this.state.style, visibility: 'hidden'};
			select = <select {...props} {...state} {...other}>{options}</select>;
		}
		return(
			<>
				{select}
			</>
		);
	}
	// --------------------------------------------------------------------------

	// private メソッド  ---------------------------------------------------------
	/**
	 * オプションリスト取得
	 * @returns オプションリスト
	 */
	private getOptionList(): any[] {
		let options = this.props.view.vm(this.props.name, this.props.vm, this.props.row).map((kvInfo, index, array) => {
			if (this.state.readOnly)
				return <option className='wpr-select-option' key={index+1} value={kvInfo.key} disabled>{kvInfo.value}</option>;
			else
				return <option className='wpr-select-option' key={index+1} value={kvInfo.key}>{kvInfo.value}</option>;
		});
		const pholder = this.getPlaceholder();
		if (this.isErrorValue() === true)
			options.unshift(<option className='wpr-select-option' key={0} value={this.state.value} disabled style={{display: 'none'}}>{pholder}</option>);
		else if (!this.state.hissu && this.state.value)
			options.unshift(<option className='wpr-select-option' key={0} value=''> </option>);
		else
			options.unshift(<option className='wpr-select-option' key={0} value='' disabled style={{display: 'none'}}>{pholder}</option>);
		return options;
	}

	/**
	 * placeholder情報取得
	 * @returns placeholder情報
	 */
	private getPlaceholder(): string {
		if (this.state.placeholder)
			return this.state.placeholder;
		if (this.props.placeholder)
			return this.props.placeholder;
		return ' ';
	}

	/**
	 * エラー値取得
	 * @return trueの場合、エラー値
	 */
	private isErrorValue(): boolean {
		if (this.state.value === '' || this.state.value === undefined || this.state.value === null)
			return false;
		for(const info of this.props.view.vm(this.props.name, this.props.vm, this.props.row)) {
			if (info.key == this.state.value)
				return false;
		}
		return true;
	}
	// --------------------------------------------------------------------------
}